import { IShareAxios } from "../IShareAxios";
import Axios from "axios";

export class ShareAxios implements IShareAxios {
    public GetSharedReportByGuid(reportType: string, guid: string) {
        return new Promise((resolve, reject) => {
            Axios.get(`/services/gps/Share/${reportType}/${guid}`)
                .then((data) => {
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
}
